import { render, staticRenderFns } from "./PracticeModal.vue?vue&type=template&id=397851d4"
import script from "./PracticeModal.vue?vue&type=script&lang=js"
export * from "./PracticeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports